import { useMutation } from "react-query";
import http from "infra/http";

function useFinishOnboarding(tenantId: string) {
  return useMutation(
    () => {
      return http.post(`/v1/auth/finish-onboarding/tenants/${tenantId}`);
    },
    { retry: false }
  );
}

export default useFinishOnboarding;
